import React from "react";

// Crisp line-art "W bag" (WWG shopping bag) that matches the react-ikonate
// stroke style used by the other nav icons. Scales without the blur the
// previous raster PNG had.
export function WBagIcon({ size = 24, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.5 7h19l-1.15 14.5a1 1 0 0 1-1 .9H4.65a1 1 0 0 1-1-.9L2.5 7Z" />
      <path d="M6.8 7V5.2a6 6 0 0 1 10.4 0V7" />
      <path d="M7 11l2 6.5 3-4.5 3 4.5 2-6.5" />
    </svg>
  );
}

export default WBagIcon;
